// FILE: /src/Components/Social Desings/LinkedInModal.js (FULLY UPDATED)

import React, { useState } from 'react';
import { Skeleton } from 'antd';
import UserName from '../../Comman Components/UserName';
import Images from '../../Comman Components/Images';

export default function LinkedInModal({ mediaItems = [], captions = '', profile, linkedinOptions }) {
    const [open, setOpen] = useState(true);

    const isArticle = !!linkedinOptions?.articleUrl && mediaItems.length === 0;
    const isDocument = mediaItems.length === 1 && mediaItems[0].type === 'document';
    const isSingleImage = mediaItems.length === 1 && mediaItems[0].type === 'image';
    const isSingleVideo = mediaItems.length === 1 && mediaItems[0].type === 'video';
    const isCarousel = mediaItems.length > 1 && mediaItems.every(item => item.type === 'image');

    const renderMediaPreview = () => {
        if (isArticle) {
            // --- THIS IS THE FIX: A try-catch block handles invalid URL inputs gracefully. ---
            let hostname = 'example.com';
            try {
                // This will only run if the URL is valid enough to be parsed.
                if (linkedinOptions.articleUrl) {
                    hostname = new URL(linkedinOptions.articleUrl).hostname;
                }
            } catch (error) {
                // If a user types an incomplete URL (e.g., "http://"), the new URL() constructor
                // would crash the app. This catch block prevents the crash.
                console.warn("Invalid URL for LinkedIn preview:", linkedinOptions.articleUrl);
            }
            return (
                <div className="border rounded-lg bg-gray-50 p-3">
                    <p className="font-semibold text-sm truncate">{linkedinOptions.articleTitle || "Your Article Title Here"}</p>
                    <p className="text-xs text-gray-500">{hostname}</p>
                </div>
            );
        }
        if (isDocument) {
            return (
                <div className="border rounded-lg bg-gray-100 p-4 flex items-center gap-4">
                    <i className="fa-solid fa-file-alt text-4xl text-gray-500"></i>
                    <div>
                        <p className="font-bold text-gray-800">{linkedinOptions.documentTitle || "Document Title"}</p>
                        <p className="text-xs text-gray-500">{mediaItems[0].file?.name || "document.pdf"}</p>
                    </div>
                </div>
            );
        }
        if (isSingleImage) {
            const url = mediaItems[0].permanentUrl || mediaItems[0].localUrl;
            return <img src={url} className="w-full h-auto max-h-96 object-cover rounded-lg border" alt="Post preview" />;
        }
        if (isSingleVideo) {
             const url = mediaItems[0].permanentUrl || mediaItems[0].localUrl;
            return <video src={url} controls className="w-full h-auto max-h-96 object-contain bg-black rounded-lg" />;
        }
        if (isCarousel) {
            return (
                <div className="grid grid-cols-2 gap-1">
                    {mediaItems.slice(0, 4).map((item, index) => {
                        const url = item.permanentUrl || item.localUrl;
                        return <img key={index} src={url} className="aspect-square object-cover rounded" alt={`Carousel item ${index+1}`} />
                    })}
                </div>
            );
        }
        return null;
    };

    return (
        <div className="w-full max-w-md mx-auto my-4 border border-gray-300 rounded-xl">
            <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-3 font-semibold text-left">
                <div className="flex items-center gap-2">
                    <i className="fa-brands fa-linkedin text-blue-700 text-lg"></i>
                    <span>LinkedIn</span>
                </div>
                <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
            </button>

            {open && (
                <div className="border-t border-gray-200 p-4">
                    <header className="flex items-start gap-3 mb-3">
                        {profile ? <Images Id={profile.platform_id} /> : <Skeleton.Avatar active size="large" shape="circle" />}
                        <div>
                            <div className="font-bold text-sm">{profile ? <UserName Id={profile.platform_id} /> : <Skeleton.Input style={{ width: 150, height: 16 }} active size="small" />}</div>
                            <div className="text-xs text-gray-500">Promoted · <i className="fa-solid fa-earth-americas"></i></div>
                        </div>
                    </header>

                    <div className="text-sm whitespace-pre-wrap mb-3">
                        {captions || <span className="text-gray-400 italic">The main caption will appear here...</span>}
                    </div>
                    
                    {renderMediaPreview()}

                    <footer className="flex justify-start items-center p-1 mt-3 text-gray-600 font-semibold text-sm border-t">
                        <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2"><i className="fa-regular fa-thumbs-up"></i>Like</button>
                        <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2"><i className="fa-regular fa-comment-dots"></i>Comment</button>
                        <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2"><i className="fa-solid fa-retweet"></i>Repost</button>
                        <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2"><i className="fa-solid fa-paper-plane"></i>Send</button>
                    </footer>
                </div>
            )}
        </div>
    );
}